import React, { memo } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";

export const FormTagAtendimento = memo(({tag, handleSalvarTag, closeModal}) => {
  const methods = useForm({defaultValues: tag});

  const handleOnSubmit = (data) => {
    handleSalvarTag(data);
  }

  return(
    <Form onSubmit={methods.handleSubmit(handleOnSubmit)}>
      <Row>
        <Form.Group as={Col} className="mb-3" controlId="formBasicEmail">
          <Form.Label>Nome</Form.Label>
          <Form.Control 
            name="nome"
            type="text" 
            placeholder="Digite o nome da tag de atendimento"
            {...methods.register("nome", { required: true })}
          />
        </Form.Group>
      </Row>
      <Row>
        <Col className="novoTemplate border-top">
          <div className="buttonsTemplate">
            <Button variant="secondary" className="submitTemplate fecharModal" type="button" onClick={() => closeModal()}>
              Fechar
            </Button>
            <Button className="submitTemplate" type="submit">
              Salvar
            </Button>
          </div>
        </Col>
      </Row>

    </Form>
  )
})
